<template>
  <form
    class="search"
    :class="{ search_expanded: isSearchExpanded }"
    @submit.prevent="search"
  >
    <input
      v-model="query"
      ref="input"
      class="search__input"
      type="text"
      :placeholder="isMobile ? $t('SEARCH_MOBILE_PLACEHOLDER') : $t('SEARCH_PLACEHOLDER')"
    />
    <button class="search__button" type="submit">
      <img
        class="search__icon search__icon_desktop"
        src="@/assets/icon-search.svg"
        alt="Search"
      />
      <img
        @click.prevent="toggleSearch"
        class="search__icon search__icon_mobile"
        src="@/assets/icon-search-mobile.svg"
        alt="Search"
      />
    </button>
  </form>
</template>

<script>
export default {
  data() {
    return {
      query: '',
      isMobile: window.innerWidth <= 767 || window.innerHeight <= 767,
    };
  },
  computed: {
    isSearchExpanded() {
      return this.$store.getters.isSearchExpanded;
    },
  },
  methods: {
    toggleSearch() {
      if (!this.isSearchExpanded) {
        this.$store.commit('isSearchExpanded', true);
        this.$nextTick(() => this.$refs.input.focus());
      }
    },
    handleSearch(e) {
      if (e.path.some(el => typeof el.className === 'string' && el.className.split(' ').includes('search'))) {
        return;
      }
      this.$store.commit('isSearchExpanded', false);
    },
    search() {
      let query = {
        query: this.query,
      };
      if (/^\/search/.test(this.$route.path)) {
        query = {
          ...this.$route.query,
          ...query,
        };
      }
      this.$router.push({ path: '/search', query });
      this.query = '';
      this.$refs.input.blur();
      this.$store.commit('isSearchExpanded', false);
    },
  },
  mounted() {
    document.body.addEventListener('click', this.handleSearch);
  },
  destroyed() {
    document.body.removeEventListener('click', this.handleSearch);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.search {
  width: 365px;
  position: relative;

  @include notebook {
    width: auto;
  }

  &_expanded {
    @include notebook {
      width: auto;
      flex-grow: 1;
      z-index: 10;
    }
  }

  &_expanded &__input {
    @include notebook {
      display: block;
    }
  }

  &_expanded &__button {
    position: absolute;
    margin: auto;
  }

  &__input,
  &__button {
    background-color: var(--tertiary-bg);
  }

  &__input {
    width: 100%;
    padding: 9px 30px 9px 10px;
    font-size: $text-primary-size;
    border-radius: 2px;
    border: 1px solid var(--tertiary-accent);
    font-weight: 500;
    color: var(--text-primary);

    @include notebook {
      display: none;
      font-size: 12px;
      height: 41px;
      -webkit-appearance: none;

      &:focus {
        border: 1px solid var(--tertiary-accent) !important;
      }
    }

    @include tablet {
      font-size: 16px;
    }

    &::placeholder {
      color: var(--text-primary);
      font-weight: 400;

      @include notebook {
        color: $text-secondary;
      }
    }
  }

  &__button {
    position: absolute;
    width: 16px;
    height: 16px;
    right: 8px;
    top: 2px;
    bottom: 0;
    margin: auto;

    @include notebook {
      background: none;
      position: static;
      margin-top: 4px;
      margin-right: 8px;
    }
  }

  &__icon {
    &_mobile {
      display: none;

      @include notebook {
        display: block;
        filter: var(--img-filter);
      }
    }

    &_desktop {
      @include notebook {
        display: none;
      }
    }
  }
}
</style>
